"use client"

import React from "react"
import { useSearchParams } from "next/navigation"

import { parseIframeUrl } from "@/lib/utils"

interface IframeProps {
  iframe: string
  title?: string
}

const Iframe = React.forwardRef<HTMLDivElement, IframeProps>(
  ({ iframe, title }, ref) => {
    const searchParams = useSearchParams()
    const parsedIframe = parseIframeUrl(iframe)

    const custom_fields = searchParams.get("custom_fields")

    const addCustomFields = (content: string | undefined) => {
      if (!custom_fields) return content
      const url = new URL(content ?? "")
      url.searchParams.append("custom_fields", custom_fields)

      return url.toString()
    }

    return (
      <div className="mb-13 lg:mb-17" ref={ref}>
        <iframe
          className="min-h-full"
          width="100%"
          src={addCustomFields(parsedIframe?.url)}
          height={parsedIframe?.height}
          title={title || "Contenu intégré"}
        ></iframe>
      </div>
    )
  }
)

export { Iframe, type IframeProps }
